import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef, ChangeDetectionStrategy, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Router, ActivatedRoute } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { WebResService } from '../webresolution/service/webresservices';
import {InvoiceAttachmentsDTO} from '../webresolution/model/InvoiceAttachmentsDTO';
import * as XLSX from 'xlsx';
import { DashboardService } from './service/dashboardservice';
import { AttachDocumentModalComponent } from '../webresolution/modal/attachDocument.component';
import {MessageBox} from '../commoncomponent/MessageBox/MessageBox';
import * as _ from 'lodash';
import { WindowService } from '@progress/kendo-angular-dialog';
import {AttachComponent} from '../commoncomponent/AttachComponent/attach.component'
import {saveAs as importedSaveAs} from "file-saver"; 
import { orderBy, SortDescriptor } from '@progress/kendo-data-query';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';

const others: Array<any> = [ 100, 101, 102, 105, 107, 110, 113, 114, 115, 116, 117, 118, 119 ];

const INPROGRESS_STATUS = [ 100, 101, 102, 105, 107, 110, 113, 114,115, 116, 117,118, 119 ];

const WEB_REPLIES = [ 107 ];

declare global {
    interface Navigator {
      msSaveOrOpenBlob: (blobOrBase64: Blob | string, filename: string) => void
    }
}

interface Invoice {
    userType: string,
    id: number
}
interface Shipments {
    Id:  number,
    ShipmentMode: string,
    ServiceLevel: string,
    OriginCountryCode: string,
    DestinationCountryCode: string,
    ShipmentCurrencyCode: string,
    BilledAmount: number,
    Freight: number,
    FuelSurcharge: number,
    Surcharge: number,
    Warehouse: string,
    GroupDutyTax: string,
    Local: string
    Other: number,
    UnitsOfMeasureDescription: Array<string>,
    UnitsOfMeasureAmount: Array<string>
 }
 interface CommentHistory{
    posteDate: string,
    userCompany: string,
    userFirstName: string,
    userLastName: string,
    userMessage: string,
    userinitial: string
 }
 interface InvoiceIds{
    id: number,
    invoiceId: number,
    name: string,
    value: string
 }
 interface InvoiceHistory{
    id: number,
    invoiceId: number,
    status: number,
    description: string,
    historyDate: string,
    userId: number
 }
interface InvoiceResult{
    DaysInResolution: string,
    Client: {
        Name: string,
        Country: string,
        City: string
        Address1: string
        Address2: string
    },
    Carrier: {
        Name: string,
        Country: string,
        City: string,
        Address1: string,
        Address2: string
     },
     InvoiceNo: string,
     InvoiceDate: string,
     DueDate: string,
     Currency: string,
     BilledAmount: number,
     DaysToDueDate: string,
     Shipments: Array<Shipments>,
     ResolutionReasonCode: string,
     ResolutionDescription: string,
     ResolutionAuditorsRemarks: string,
     LatestComments: {
        userFirstName: string,
        userinitial: string,
        posteDate: string,
        userCompany: string,
        userMessage: string
     },
     OldiestHistory: {
        userFirstName: string,
        userinitial: string,
        posteDate: string,
        userCompany: string,
        userMessage: string
     },
     InvoiceIds: Array<InvoiceIds>,
     InvoiceHistories: Array<InvoiceHistory>,
     CommentHistory: Array<CommentHistory>,
     StatusId: number,
     Status: string,
     InvoiceFile: string,
     Id: number
}

@Component({
    templateUrl: './details.html',
    styleUrls: ['./details.css'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DetailsComponent implements OnInit, AfterViewInit {
    @ViewChild('noimg', {static: false}) noimg: ElementRef;
    @ViewChild('invoicePDF', {static: false}) invoicePDF: ElementRef;
    public sortGrid: SortDescriptor[];
    invoiceData: Invoice;
    invoiceResult: InvoiceResult;
    shipments: Array<any> = [];
    selectedShipment: any;
    isCollapsible: boolean = false;
    isVisible: boolean = false;
    shipmentInformation: any;
    titleShipment: string;
    total: any;
    totalAmount:Number = 0;
    public gridViewInvoiceSIDsCopy: any;
    public gridViewInvoiceClientFieldsCopy: any;
    public gridViewInvoiceUomsCopy: any;
    public gridViewInvoiceAccessorialsCopy: any;
  
    public sortGridInvoiceSIDs: SortDescriptor[];
    public sortGridClientFields: SortDescriptor[];
    public sortGridInvoiceUoms: SortDescriptor[];
    public sortGridInvoiceAccessorials: SortDescriptor[];
  
    public gridViewInvoiceSIDs: any;
    public gridViewInvoiceClientFields: any;
    public gridViewInvoiceUoms: any;
    public gridViewInvoiceAccessorials: any;

    public windowTop = 200;
    public windowLeft = 450;
    public allocation:string="";
    public fileAttachment:Array<InvoiceAttachmentsDTO>= [];
    public gridHeight = {
        height: 'calc(100vh - 140px)'
     };
    tabs = [1, 2, 3];
    public _countriesListPerm: Array<any>;
    public showAttachDocument:boolean = false;
    fileCount: number;
    hasWebRes:boolean = false;
    showIframeLoader:boolean = false;
    public invoiceId: Number;
    public pageSize = 10;
    public skip = 0;
    public shipmentGridView: GridDataResult;
    public OriginDestination = [];
    public services = [];
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _dashboardService: DashboardService,
        private cd: ChangeDetectorRef,
        private _messageBox: MessageBox,
        private _webResService: WebResService,
        private router: Router,
        private _windowService: WindowService,
        private domSanitizer: DomSanitizer
    ){

    }

    ngOnInit(){

    }

    showIFrame(){
        this.noimg.nativeElement.style.display = 'none';
        this.invoicePDF.nativeElement.style.display = 'block';
    }
    
    showNoImage(){
        this.invoicePDF.nativeElement.style.display = 'none';
        this.noimg.nativeElement.style.display = 'block';
    }
    
    originalBlob: any = null;

    ngAfterViewInit(){
        this.showNoImage();
        
        this._activatedRoute.params.subscribe(params => {

            this.invoiceId = params['invoiceId'];
            this.originalBlob = null;

            this._dashboardService.getInvoiceById(this.invoiceId).subscribe((data) => 
            {
                this.invoiceResult = data;
                console.log(data);
                
                this.shipmentGridView = {
                    data: this.invoiceResult.Shipments.slice(this.skip, this.skip + this.pageSize),
                    total: this.invoiceResult.Shipments.length
                };
                this.changeDetection();
                this.showIframeLoader = true;
                let theFile;

                this._webResService.getWebResAttachmentOpenPDF(this.invoiceResult.InvoiceFile,"n",this.invoiceResult.Id)
                .subscribe((blobObj) => {
                   this.originalBlob = blobObj;
                   theFile = new Blob([blobObj], { type: 'application/octet-stream' });
                   this.showIFrame();
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(theFile, this.invoiceResult.InvoiceFile+'.pdf');
                    } 
                    else {
                        var url = window.URL.createObjectURL(blobObj);
                        window.open(url, "invoicePDFframe");
                    }
                    this.showIframeLoader = false;
                },
                (err) => {
                    this.showNoImage();
                    this.showIframeLoader = false;
                    }
                );
            });
            this._dashboardService.getAllocation(this.invoiceId).subscribe((data)=>{
                this.allocation = data.Value;
            });
            this._dashboardService.HasWebResAccess(this.invoiceId).subscribe((data)=>{
                this.hasWebRes = data;
            });
        })

      
    }

    pdfSrc: any;

    detectCollapse(collapsed: any){
        if(!collapsed){
            var blobObj = this.originalBlob;

            if(blobObj == null){
                this.showNoImage();
                return;
            }

            var theFile = new Blob([blobObj], { type: 'application/octet-stream' });

            this.showIFrame();
             if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                 window.navigator.msSaveOrOpenBlob(theFile, this.invoiceResult.InvoiceFile+'.pdf');
                 console.log('navigator');
             } 
             else {
                //  var url = window.URL.createObjectURL(blobObj);
                //  window.open(url, "invoicePDFframe");
                this.pdfSrc = this.domSanitizer.bypassSecurityTrustResourceUrl(
                    URL.createObjectURL(blobObj)
                );
                 console.log('iframe')
             }
        }
    }

    public pageChange(event: PageChangeEvent): void {
        this.skip = event.skip;
        this.shipmentGridView = {
            data: this.invoiceResult.Shipments.slice(this.skip, this.skip + this.pageSize),
            total: this.invoiceResult.Shipments.length
        };
    }

    public onChangePage(invdata: Array<any>) {
        this.shipments = invdata;
    }
    containsOpen(statusNo: string){
        return others.includes(statusNo);
    }
    changeDetection(){
        this.cd.markForCheck();
        this.cd.detectChanges();
    }
    back(){
        this.router.navigate(['starter/index']);
    }
    showShipmentDetails(shipment: any){
        var scope = this;
        this.selectedShipment = shipment;
        this._dashboardService.getCountriesList().subscribe(data=>{
            this._countriesListPerm = data;
        })
        this._dashboardService.getShipmentInformation(shipment.Id).subscribe(x => {
            console.log(x);
            this.titleShipment = `Shipment ID ${shipment.Id}`
            this.shipmentInformation = x;
            this.gridViewInvoiceSIDsCopy = x;
            this.gridViewInvoiceClientFieldsCopy = x;
            this.gridViewInvoiceUomsCopy = x;
            this.gridViewInvoiceAccessorialsCopy = x;
            this.total = x;
            console.log(this.total);
            this.totalAmount = this.total.ShipmentAmount;
            //var temp = {"col1":this.shipmentInformation?.OriginCity,"col2":"colValue2"};
            this.OriginDestination = [{"col1":this.shipmentInformation.OriginCity,"col2":this.shipmentInformation.DestinationCity,"col3":this.shipmentInformation.ShipmentMode },
                {"col1":this.shipmentInformation.OriginPostCode,"col2":this.shipmentInformation.DestinationPostCode,"col3":""},
                {"col1":this.shipmentInformation.OriginCountryCode ,"col2":this.shipmentInformation.DestinationCountryCode,"col3":""},
            ];
       
            this.services = [{"col1":this.shipmentInformation.ServiceType,"col2":this.shipmentInformation.FreightTerms,"col3":this.shipmentInformation.ShipmentDate,"col4":this.shipmentInformation.DeliveryDate }]
          
            scope.gridViewInvoiceClientFields = {
                data: scope.gridViewInvoiceClientFieldsCopy.InvoiceClientFields,
                total: scope.gridViewInvoiceClientFieldsCopy.InvoiceClientFields.length
              };
        
              scope.gridViewInvoiceSIDs = {
                data: scope.gridViewInvoiceSIDsCopy.InvoiceSIDs,
                total: scope.gridViewInvoiceSIDsCopy.InvoiceSIDs.length
              };
        
              scope.gridViewInvoiceUoms = {
                data: scope.gridViewInvoiceUomsCopy.InvoiceUoms, 
                total: scope.gridViewInvoiceUomsCopy.InvoiceUoms.length
              };
        
              scope.gridViewInvoiceAccessorials = {
                data: scope.gridViewInvoiceAccessorialsCopy.InvoiceAccessorials,
                total: scope.gridViewInvoiceAccessorialsCopy.InvoiceAccessorials.length
              };
            this.isVisible = true;
            this.changeDetection();
        })
    }

    public sortChangeInvoiceSIDs(sortGridInvoiceSIDs: SortDescriptor[]): void {
        this.sortGridInvoiceSIDs = sortGridInvoiceSIDs;
        this.loadshipmentInvoiceSIDs();
        this.changeDetection();
      }
      public loadshipmentInvoiceSIDs(): void {
        this.gridViewInvoiceSIDs = {
            data: orderBy(this.gridViewInvoiceSIDsCopy.InvoiceSIDs, this.sortGridInvoiceSIDs),
            total: this.gridViewInvoiceSIDsCopy.InvoiceSIDs.length
        };
      }
    
      public sortChangeInvoiceClientFields(sortGridClientFields: SortDescriptor[]): void {
        this.sortGridClientFields = sortGridClientFields;
        this.loadshipmentClientFields();
        this.changeDetection();
      }
      public loadshipmentClientFields(): void {
        this.gridViewInvoiceClientFields = {
            data: orderBy(this.gridViewInvoiceClientFieldsCopy.InvoiceClientFields, this.sortGridClientFields),
            total: this.gridViewInvoiceClientFieldsCopy.InvoiceClientFields.length
        };
    }
    
    public sortChangeInvoiceInvoiceUoms(sortGridInvoiceUoms: SortDescriptor[]): void {
        this.sortGridInvoiceUoms = sortGridInvoiceUoms;
        this.loadshipmentInvoiceUoms();
        this.changeDetection();
      }
      public loadshipmentInvoiceUoms(): void {
        this.gridViewInvoiceUoms = {
            data: orderBy(this.gridViewInvoiceUomsCopy.InvoiceUoms, this.sortGridInvoiceUoms),
            total: this.gridViewInvoiceUomsCopy.InvoiceUoms.length
        };
    }
    
    public sortChangeInvoiceInvoiceAccessorials(sortGridInvoiceAccessorials: SortDescriptor[]): void {
        this.sortGridInvoiceAccessorials = sortGridInvoiceAccessorials;
        this.loadshipmentInvoiceAccessorials();
        this.changeDetection();
      }
      public loadshipmentInvoiceAccessorials(): void {
        this.gridViewInvoiceAccessorials = {
            data: orderBy(this.gridViewInvoiceAccessorialsCopy.InvoiceAccessorials, this.sortGridInvoiceAccessorials),
            total: this.gridViewInvoiceAccessorialsCopy.InvoiceAccessorials.length
        };
    }
    handleCancel(){
        this.isVisible = false;
    }
    handleOk(){
        this.isVisible = false;
    }
    invoiceAttachment: Array<any>;
    public showDownload:boolean = false;
    viewDocument(){
        var scope = this;
        this._webResService.getFileAttachment(this.invoiceResult.Id.toString()) .subscribe((data:Array<InvoiceAttachmentsDTO>) => {
            scope.invoiceAttachment = data;
            if(scope.invoiceAttachment.length > 0){
                scope.showDownload = true;
                this.changeDetection();
            }else{
                scope._messageBox.open("No Attachment!");
            }
        });
    }
    public onSelectEvent(e) {
        this.fileCount += 1;
      }
    attachDocument(){
        this.showAttachDocument = true;
        const windowRef = this._windowService.open({
            title: 'Attach Document',
            content: AttachComponent,
            width: 450
        });
        const attachInstance = windowRef.content.instance;
        attachInstance.commaSeparatedInvId = this.invoiceId.toString();
    }

    closeAttach(){
        this.showAttachDocument = false;
    }
    exportData(){
        var excelData = [];
        this.invoiceResult.Shipments.forEach((value, index)=>{
            let uomDesc = (value.UnitsOfMeasureDescription.length > 0)? value.UnitsOfMeasureDescription[0]:"";
            let uomAmount = (value.UnitsOfMeasureAmount.length > 0)? value.UnitsOfMeasureAmount[0]:0;
            let uomDesc1 = (value.UnitsOfMeasureDescription.length > 1)? value.UnitsOfMeasureDescription[1]:"";
            let uomAmount1 = (value.UnitsOfMeasureAmount.length > 1)? value.UnitsOfMeasureAmount[1]:0;
            let uomDesc2 = (value.UnitsOfMeasureDescription.length > 2)? value.UnitsOfMeasureDescription[2]:"";
            let uomAmount2 = (value.UnitsOfMeasureAmount.length > 2)? value.UnitsOfMeasureAmount[2]:0;
            excelData.push(
                  {
                  'Id':index + 1,
                  'Shipment Id':value.Id,
                  'ShipmentMode.Name':value.ShipmentMode,
                  'ServiceLevel.Name':value.ServiceLevel,
                  'OriginCountryCode':value.OriginCountryCode,
                  'DestinationCountryCode':value.DestinationCountryCode,
                  'ShipmentCurrency.Code':value.ShipmentCurrencyCode,
                  'BilledAmount':value.BilledAmount,
                  'Freight':value.Freight,
                  'FuelSurcharge':value.FuelSurcharge,
                  'Surcharge':value.Surcharge,
                  'Warehouse':value.Warehouse,
                  'GroupDutyTax':value.GroupDutyTax,
                  'Local':value.Local,
                  'Other':value.Other,
                  'UOM.Description':uomDesc,
                  'Amount':uomAmount,
                  'UOM.Description1':uomDesc1,
                  'Amount1':uomAmount1,
                  'UOM.Description3':uomDesc2,
                  'Amount3':uomAmount2,
                }
              )
          });
          
          const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);
          ws.A1.v = "Shipment Number";
          ws.B1.v = "Shipment ID";
          ws.C1.v = "Mode";
          ws.D1.v = "Origin";
          ws.E1.v = "ServiceLevel";
          ws.F1.v = "Destination";
          ws.G1.v = "Shipment Currency";
          ws.H1.v = "Billed Amount";
          ws.I1.v = "Freight";
          ws.J1.v = "Fuel Surcharge";
          ws.K1.v = "Surcharge";
          ws.L1.v = "Warehouse";
          ws.M1.v = "GroupDutyTax";
          ws.N1.v = "Local";
          ws.O1.v = "Other";
          ws.P1.v = "Uom Name1";
          ws.Q1.v = "Uom Value1";
          ws.R1.v = "Uom Name2";
          ws.S1.v = "Uom Value2";
          ws.T1.v = "Uom Name3";
          ws.U1.v = "Uom Value3";
          const wb: XLSX.WorkBook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, 'Shipment Information');
          XLSX.writeFile(wb, 'shipmentInformation.xlsx');
    }
    closeDownload(){
        this.showDownload = false;
    }
    
    searchCountry(country: any): any{
        var countryDetail = _.find(this._countriesListPerm, { alpha2Code: country });
        return countryDetail;       
      }
    getCountryFlag(data: any){
        var flag = this.searchCountry(data).flag;
        return flag;
      }

      
    public downloadAttachment(attachment){
        this._webResService.getWebResAttachment(attachment.EncPath,"y",attachment.InvoiceId).subscribe((data) =>{
        importedSaveAs(data, attachment.RawFileName);
        });
    }
    goToBottom(){
        window.scrollTo(0,document.body.scrollHeight);
    }

    scroll(el: HTMLElement) {
        el.scrollIntoView();
    }

    filterStatus(data: any): string{
        if(data !== undefined){
            if( INPROGRESS_STATUS.find(e => e == data.StatusId) !== undefined)
            {
                if(WEB_REPLIES.find(x => x == data.StatusId) !== undefined){
                    return "Web Replies";
                }
                return "In Progress"

            } else {
                return data.Status
            }
        }
        return null;
    }
}